(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4053],{

/***/ 1507:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone-verification",
      function () {
        return __webpack_require__(92550);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var EmptyLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyLayout);


/***/ }),

/***/ 92550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ phone_verification; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/layouts/EmptyLayout.tsx
var EmptyLayout = __webpack_require__(56428);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(4601);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/shared/types/certification.ts
var certification = __webpack_require__(61607);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/views/phone-verification/hooks/usePhoneVerificationViewModel.ts








var usePhoneVerificationViewModel = function() {
    var router = (0,next_router.useRouter)();
    var toast = (0,index_es/* useToast */.pm)().toast;
    var _query = router.query, result = _query.result, responseEncodeData = _query.EncodeData, redirectUrl = _query.redirectUrl;
    var ref = (0,react.useState)(null), requestEncodeData = ref[0], setRequestEncodeData = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), certificationAlertOpen = ref2[0], setCertificationAlertOpen = ref2[1];
    var processedRef = (0,react.useRef)(false);
    var sendCertificationMessage = (0,react.useCallback)(function(type) {
        var message = {
            type: type,
            timestamp: Date.now()
        };
        if (window.opener && !window.opener.closed) {
            try {
                window.opener.postMessage(message, window.location.origin);
            } catch (error) {
                console.error("window.opener.postMessage failed:", error);
            }
        }
        if ("BroadcastChannel" in window) {
            try {
                var channel = new BroadcastChannel(certification/* CERTIFICATION_CHANNEL_NAME */.B);
                channel.postMessage(message);
                channel.close();
            } catch (error1) {
                console.error("BroadcastChannel failed:", error1);
            }
        }
    }, []);
    var onCloseCertificationPopup = (0,react.useCallback)(function() {
        setCertificationAlertOpen(false);
        if (redirectUrl && typeof redirectUrl === "string") {
            router.replace(redirectUrl);
        } else {
            window.close();
        }
    }, [
        router,
        redirectUrl
    ]);
    var processCertification = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(requestEncodeData) {
            var config, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = {
                            encodeData: requestEncodeData,
                            path: "auth"
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetcher/* RestApi.post */.Kk.post("v1/auth/certifyByPhone", config)
                        ];
                    case 2:
                        _state.sent();
                        sendCertificationMessage(certification/* CERTIFICATION_MESSAGE_TYPE.SUCCESS */.i.SUCCESS);
                        if (redirectUrl && typeof redirectUrl === "string") {
                            router.replace(redirectUrl);
                        } else {
                            window.close();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        sendCertificationMessage(certification/* CERTIFICATION_MESSAGE_TYPE.FAIL */.i.FAIL);
                        toast({
                            text: (0,_instanceof/* default */.Z)(error, Error) ? error.message : "본인인증에 실패했습니다. 다시 시도해주세요.",
                            direction: "bottom"
                        });
                        if (!redirectUrl) {
                            window.close();
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(requestEncodeData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router,
        redirectUrl,
        toast,
        sendCertificationMessage
    ]);
    var fetchCertificationData = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, returnUrlBase, returnUrl, response, encodeData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    returnUrlBase = "".concat("https://doctornow.co.kr", "/phone-verification?result=success");
                    returnUrl = redirectUrl && typeof redirectUrl === "string" ? "".concat(returnUrlBase, "&redirectUrl=").concat(encodeURIComponent(redirectUrl)) : returnUrlBase;
                    return [
                        4,
                        fetcher/* RestApi.get */.Kk.get("v1/auth/certifyByPhone", {
                            params: {
                                returnUrl: returnUrl,
                                errorUrl: "".concat("https://doctornow.co.kr", "/phone-verification?result=fail")
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    encodeData = ((ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.EncodeData) || null;
                    setRequestEncodeData(encodeData);
                    return [
                        3,
                        4
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Certification data fetch error:", error);
                    setCertificationAlertOpen(true);
                    return [
                        3,
                        4
                    ];
                case 3:
                    setIsLoading(false);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        redirectUrl
    ]);
    var submitForm = (0,react.useCallback)(function() {
        var form = document.getElementById("niceForm");
        if (form) {
            form.submit();
        }
    }, []);
    (0,react.useEffect)(function() {
        fetchCertificationData();
    }, []);
    (0,react.useEffect)(function() {
        if (result === "success" && !processedRef.current) {
            processedRef.current = true;
            processCertification(responseEncodeData);
            return;
        }
        if (result === "success" && processedRef.current) {
            return;
        }
        if (result === "fail") {
            setCertificationAlertOpen(true);
            return;
        }
        if (!requestEncodeData || requestEncodeData === null) {
            if (!isLoading) {
                setCertificationAlertOpen(true);
            }
            return;
        }
        setTimeout(submitForm, 100);
    }, [
        requestEncodeData,
        result,
        responseEncodeData,
        processCertification,
        isLoading,
        submitForm
    ]);
    return {
        requestEncodeData: requestEncodeData,
        isLoading: isLoading,
        certificationAlertOpen: certificationAlertOpen,
        onCloseCertificationPopup: onCloseCertificationPopup
    };
};
/* harmony default export */ var hooks_usePhoneVerificationViewModel = (usePhoneVerificationViewModel);

;// CONCATENATED MODULE: ./src/views/phone-verification/ui/PhoneVerificationView.tsx



var NICE_CERTIFICATION_SERVICE_URL = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
var PhoneVerificationView = function() {
    var ref = hooks_usePhoneVerificationViewModel(), requestEncodeData = ref.requestEncodeData, isLoading = ref.isLoading, certificationAlertOpen = ref.certificationAlertOpen, onCloseCertificationPopup = ref.onCloseCertificationPopup;
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex min-h-screen items-center justify-center bg-gray-50",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto mb-[16px] h-[32px] w-[32px] animate-spin rounded-full border-blue-600 border-b-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-gray-600",
                        children: "본인인증을 준비하고 있습니다..."
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "min-h-screen bg-gray-50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                id: "niceForm",
                name: "form_chk",
                method: "post",
                action: NICE_CERTIFICATION_SERVICE_URL,
                target: "_self",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "m",
                        value: "checkplusService"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "EncodeData",
                        value: requestEncodeData || ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "hidden",
                        name: "recvMethodType",
                        value: "get"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Alert */.bZ, {
                type: "single",
                title: "본인인증 실패",
                description: "본인인증에 실패했습니다. 다시 시도해주세요.",
                open: certificationAlertOpen,
                onOpenChange: onCloseCertificationPopup,
                buttons: [
                    {
                        label: "확인",
                        onClick: onCloseCertificationPopup
                    }, 
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_PhoneVerificationView = (PhoneVerificationView);

;// CONCATENATED MODULE: ./src/pages/phone-verification/index.tsx
// PageDescription: 본인인증 화면



var PhoneVerificationPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_PhoneVerificationView, {});
};
/* harmony default export */ var phone_verification = (PhoneVerificationPage);
PhoneVerificationPage.Layout = EmptyLayout/* default */.Z;


/***/ }),

/***/ 61607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CERTIFICATION_CHANNEL_NAME; },
/* harmony export */   "i": function() { return /* binding */ CERTIFICATION_MESSAGE_TYPE; }
/* harmony export */ });
var CERTIFICATION_CHANNEL_NAME = "doctornow-certification";
var CERTIFICATION_MESSAGE_TYPE = {
    SUCCESS: "CERTIFICATION_SUCCESS",
    FAIL: "CERTIFICATION_FAIL"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1507); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);